import { classNames } from "../../util/helpers";
import { ColumnType } from "../types";
import { CellWrapper } from "./TableCellWrapper";
import { useTableContext } from "./TableContext";
import { calculateWidth } from "./util";

/**
 * Column Cell component
 * @param ColumnType
 * @returns JSX
 */
const ColumnCell = (column: ColumnType) => {
    const table = useTableContext();
    const { sortable, accessor, isSelectColumn } = column;
    const style: React.CSSProperties = {
        ...column.style,
        width: calculateWidth(column?.width, table?.spacing ?? "default"),
        ...(column?.whiteSpace === 'nowrap' ? { whiteSpace: 'nowrap' } : {})
    }

    let classNameObject: any = {
        className: `--cell-valign-${table?.verticalAlignTh ?? 'middle'}`,
        'data-testid': accessor,
    }

    const ColumnData = typeof column.Header === 'function' ? column.Header(column) : column.Header;

    if (isSelectColumn) {
        return <td {...classNameObject} style={style}>{ColumnData}</td>
    }

    if (column.width || sortable) {
        const ariaSort = accessor === table.sortBy ? table.sortOrder : 'none';
        /** if sortable true then adding the sortable aria-sort */
        if (sortable) {
            classNameObject = {
                ...classNameObject,
                className: classNames(classNameObject.className, sortable && 'ted-ui-sortable-column'),
                "aria-sort": ariaSort
            }
        }
        return <th {...classNameObject} ><CellWrapper sortable={sortable} accessor={accessor} style={style}
            ariaDescription={ariaSort === 'none' ? 'Sortable Column' : undefined}>{ColumnData}</CellWrapper></th>;
    }

    return <th {...classNameObject} style={style}>{ColumnData}</th>;
}

export default ColumnCell;
